import React from 'react';
import { AnalyticsDate } from 'src/pages/AnalyticsPage/AnalyticsCustomer/AnalyticsDate/AnalyticsDate';
import ReportPdfBtn from 'src/pages/AnalyticsPage/AnalyticsCustomer/ReportPdfBtn';
import RefreshBtn from 'src/pages/AnalyticsPage/AnalyticsCustomer/RefreshBtn';
import EmailReportBtn from 'src/pages/AnalyticsPage/AnalyticsCustomer/EmailReportBtn';
import TimezoneSelect from 'src/pages/AnalyticsPage/AnalyticsCustomer/TimezoneSelect';
import { PdfReportHeader } from 'src/pages/AnalyticsPage/AnalyticsCustomer/PdfReportHeader';

type AnalyticsControlsHeaderProps = {
  onDateChange: (selectedOption: any) => void;
  dateRangeOptions: { label: string; disabled?: boolean; default?: boolean }[];
  statRef: React.RefObject<HTMLElement>;
};

export const AnalyticsControlsHeader = ({
  onDateChange,
  dateRangeOptions,
  statRef,
}: AnalyticsControlsHeaderProps) => (
  <div className="flex md:flex-row flex-col md:gap-[10px] gap-[6px] relative">
    <PdfReportHeader />
    <div className="flex flex-row size-full md:gap-[10px] gap-[6px] justify-between items-center analytic-header flex-wrap">
      <div className="flex flex-wrap items-center gap-2.5">
        <TimezoneSelect />
        <AnalyticsDate onDateChange={onDateChange} selectOptions={dateRangeOptions} />
        <RefreshBtn />
      </div>
      <div className="flex items-center gap-2.5">
        <EmailReportBtn />
        <ReportPdfBtn statRef={statRef} />
      </div>
    </div>
  </div>
);
